import React from 'react';
import emon from '../assets/img/emtiaz1.png';

const Hero = () => {
  return (
    <section
      id='home'
      className='lg:h-[85vh] flex items-center bg-primary lg:bg-cover lg:bg-center lg:bg-no-repeat py-32 lg:py-0 overflow-hidden'
    >
      <div className='container mx-auto h-full'>
        <div className='flex items-center h-full pt-8 lg:pt-20 '>
          <div className='flex-1 flex flex-col items-center lg:items-start lg:pl-10'>
            <p className='text-lg text-accent text-md mb-[22px]'>
              Hey, I'm Emtiaz 👋
            </p>
            <h1 className='text-4xl leading-[44px] md:text-5xl md:leading-tight lg:text-6xl lg:leading-[1.2] font-bold md:tracking-[-2px]'>
              I'm a frontend <br />  developer .
            </h1>
            <p className='pt-4 pb-8 md:pt-6 md:pb-12 max-w-[480px] text-lg text-center lg:text-left'>
              Always love to learn something new . Love to get error and handle error . If I learn something special I share this with my friends . One secret about me I'm very fast learner .
            </p>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='https://drive.google.com/file/d/1oZHJB3Uz1i1kSscH6Mc6ZDpRJ6PMZc_5/view' target="_blank" rel="noopener noreferrer"
            >
              <button className='btn btn-md bg-accent hover:bg-secondary-hover md:btn-lg transition-all'>
                View Resume
              </button>
            </a>
          </div>
          <div className='hidden lg:flex flex-1 justify-center items-center h-full'>
            <img src={emon} alt='emon' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
